import { Routes, Route, Navigate } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import PublicLayout from "./layout/PublicLayout";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/signup" element={<Pages.Signup />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/recoverymail" element={<Pages.RecoveryMail />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />

      {/* Public Routes (accessible without login or authentication) */}
      <Route element={<PublicLayout />}>
        <Route path="/public/privacy-policy" element={<Pages.PrivacyPolicy />} />
        <Route path="/public/terms-and-conditions" element={<Pages.TermsAndConditions />} />
        <Route path="/public/security-policy" element={<Pages.SecurityPolicy />} />
        <Route path="/public/faq" element={<Pages.Faq />} />
        <Route path="/public/support" element={<Pages.Support />} />
      </Route>

      {/* Public aliases */}
      <Route path="/public" element={<Navigate to="/public/privacy-policy" replace />} />
      <Route path="/public/terms" element={<Navigate to="/public/terms-and-conditions" replace />} />

      {/* Protected Admin Routes */}
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Editor />} />
        <Route path="/recent-designs" element={<Pages.RecentDesigns />} />
        <Route path="/how-it-works" element={<Pages.HowItWorks />} />
        <Route path="/manage-profile" element={<Pages.Account />} />
        <Route path="/security" element={<Pages.Account />} />
        <Route path="/support" element={<Pages.Account />} />
        <Route path="/cms" element={<Pages.Account />} />
        <Route path="/privacy-policy" element={<Pages.Account />} />
        <Route path="/faq" element={<Pages.Account />} />

        {/* Compatibility fallbacks & aliases */}
        <Route path="/manage-profile/security" element={<Navigate to="/security" replace />} />
        <Route path="/manage-profile/support" element={<Navigate to="/support" replace />} />
        <Route path="/manage-profile/faq" element={<Navigate to="/faq" replace />} />
        <Route path="/manage-profile/privacy-policy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/manage-profile/cms" element={<Navigate to="/cms" replace />} />
        <Route path="/pp" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/terms" element={<Navigate to="/cms" replace />} />
        <Route path="/terms-and-conditions" element={<Navigate to="/cms" replace />} />
      </Route>
    </Routes>
  );
};

export default Routing;
